<template>
  <div class="ds-meta">
    <span class="ds-meta__label">{{ label }}</span>
    <span class="ds-meta__value">
      <slot>{{ value }}</slot>
    </span>
    <button
      v-if="copyable"
      type="button"
      class="ds-meta__copy"
      :aria-label="`Copy ${label}`"
      @click="$emit('copy')"
    >
      <span class="material-icons">{{ copied ? 'check' : 'content_copy' }}</span>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DetailSheetMetaRow',
  props: {
    label: { type: String, required: true },
    value: { type: String, default: '' },
    copyable: { type: Boolean, default: false },
    copied: { type: Boolean, default: false },
  },
  emits: ['copy'],
});
</script>

<style scoped>
.ds-meta {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
  padding: 0.6875rem 0.875rem;
  font-size: 0.875rem;
}

.ds-meta:not(:first-child) {
  border-top: 1px solid var(--gray-border);
}

.ds-meta__label {
  flex: 0 0 auto;
  color: var(--text-muted);
}

.ds-meta__value {
  flex: 1 1 auto;
  min-width: 0;
  color: #fff;
  text-align: right;
  /* Grid references and ids should wrap rather than stretch the dialog. */
  overflow-wrap: anywhere;
}

.ds-meta__copy {
  flex: 0 0 auto;
  align-self: center;
  padding: 0;
  background: transparent;
  border: 0;
  color: var(--text-muted);
  line-height: 1;
}

.ds-meta__copy:hover {
  color: var(--yellow);
}

.ds-meta__copy .material-icons {
  font-size: 17px;
}
</style>
